import React from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import professionCases from 'helpers/professionCases';

const Title = styled(Typography)(({ theme }) => ({
  padding: '11px 25px 10px',
  fontSize: 24,
  textAlign: 'center',
  borderBottom: '1px solid #d6d6d6',
  [theme.breakpoints.down('md')]: {
    lineHeight: '34px'
  },
  [theme.breakpoints.down('sm')]: {
    textAlign: 'left'
  }
}));

const Content = styled(Typography)(({ theme }) => ({
  padding: '16px 25px',
  fontSize: 16,
  textAlign: 'left',
  [theme.breakpoints.down('md')]: {
    padding: '16px 25px'
  },
  [theme.breakpoints.down('sm')]: {
    padding: '16px 25px'
  }
}));

const StepsWrapper = styled('div')(() => ({
  padding: '0 25px',
  textAlign: 'left'
}));

const HowToTitle = styled(Typography)(() => ({
  textAlign: 'left',
  fontSize: 18,
  marginBottom: 5,
  lineHeight: 'normal'
}));

const HowToDescription = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  marginBottom: 30,
  fontSize: 16,
  [theme.breakpoints.down('sm')]: {
    marginBottom: 20
  }
}));

const Outro = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  padding: '0 25px 50px 25px',
  fontSize: 16,
  [theme.breakpoints.down('md')]: {
    paddingBottom: 30
  }
}));

const StepsToSwitchSlideComponent = ({ professionInfo, t }) => {
  return (
    <>
      <Title variant={'h1'}>
        {t('StepsToSwitch', professionCases(professionInfo, 'instrumental'))}
      </Title>

      <Content variant="body1">{professionInfo?.workHowToBecome?.intro}</Content>

      <StepsWrapper>
        {(professionInfo?.workHowToBecome?.options || []).map((option, index) => (
          <div key={option?._id}>
            <HowToTitle variant="h3">
              {index + 1}
              {'. '}
              {option?.name}
            </HowToTitle>
            <HowToDescription variant="body1">{option?.description}</HowToDescription>
          </div>
        ))}
      </StepsWrapper>

      <Outro variant="body1">{professionInfo?.workHowToBecome?.outro}</Outro>
    </>
  );
};

export default StepsToSwitchSlideComponent;
